/* eslint jsx-a11y/no-autofocus: 0 */
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Icon } from '@scentregroup/ui'
import debounce from 'lodash/debounce'
import Spinner from '../spinner'
import style from './index.scss'

const DEBOUNCED_WAIT = 200
class SearchView extends Component {
  constructor(props) {
    super(props)
    this.state = { query: props.queryText }
    this.getModal = this.getModal.bind(this)
    this.renderModalContent = this.renderModalContent.bind(this)
  }

  onQueryChangeDebounced = debounce(() => {
    this.props.onQueryChange(this.state.query)
  }, DEBOUNCED_WAIT)

  onChange = event => {
    this.setState({ query: event.target.value })
    this.onQueryChangeDebounced()
  }

  getModal() {
    if (document.getElementById('search-modal')) {
      return document.getElementById('search-modal')
    }

    const modal = document.createElement('div')
    modal.id = 'search-modal'
    document.body.appendChild(modal)
    return modal
  }

  handleKeyPress = e => {
    if (e.key === 'Enter') {
      // Trigger blur event to dismiss the Keyboard when user clicks Search in iOS.
      window.document.activeElement.blur()
    }
  }

  renderModalContent() {
    const {
      onQueryKeyDown,
      onSubmit,
      onClickClear,
      onClickClose,
      isLoading,
      results,
      queryText,
      isWevo,
    } = this.props
    const searchClassName = isWevo
      ? classNames(style.wevoTheme, style.Search)
      : style.Search
    return (
      <div className={searchClassName}>
        <button
          aria-label="Close search"
          className={style.closeButton}
          onClick={onClickClose}
        >
          <Icon type="cross" />
        </button>
        <div className={style.inputbar} onSubmit={onSubmit}>
          <form action="#" onSubmit={e => e.preventDefault()}>
            <input
              autoFocus
              id="search-textfield"
              type="search"
              className={style.textfield}
              autoCapitalize="off"
              spellCheck="false"
              autoCorrect="off"
              autoComplete="off"
              placeholder="Enter search"
              value={this.state.query}
              onChange={this.onChange}
              onKeyDown={onQueryKeyDown}
              onKeyPress={this.handleKeyPress}
            />
            <label htmlFor="search-textfield">
              <Icon type="search" className={style.searchIcon} />
            </label>
            {queryText ? (
              <button
                aria-label="Clear search text"
                className={style.clearButton}
                type="button"
                onClick={onClickClear}
              >
                <Icon type="clear" size="small" className={style.clearIcon} />
              </button>
            ) : null}
          </form>
        </div>
        {isLoading ? (
          <Spinner className={style.Spinner} />
        ) : (
          <div className={style.results}>
            {results.map(({ heading, hits }, index) => (
              <section className={style.category} key={index}>
                <h2 className={style.heading}>{heading}</h2>
                <nav className={style.resultsLinks}>{hits}</nav>
              </section>
            ))}
          </div>
        )}
      </div>
    )
  }

  render() {
    if (typeof window !== 'undefined' && this.props.isVisible) {
      return ReactDOM.createPortal(this.renderModalContent(), this.getModal())
    }
    return null
  }
}

SearchView.propTypes = {
  results: PropTypes.array,
  isLoading: PropTypes.bool,
  onQueryChange: PropTypes.func,
  onQueryKeyDown: PropTypes.func,
  onSubmit: PropTypes.func,
  onClickClear: PropTypes.func,
  onClickClose: PropTypes.func,
  queryText: PropTypes.string,
  isVisible: PropTypes.bool,
  isWevo: PropTypes.bool,
}

SearchView.defaultProps = {
  results: [],
  isLoading: false,
  queryText: '',
}

export default SearchView
